import { Announcement } from "../airtables/models";
import { teacherFieldIds } from "../airtables/tables/Teachers";
import { airtableFields } from "../airtables/schema";
import { getSession, setSession } from "../../helpers/storage";

const LAST_SEEN_ANNOUNCEMENT_KEY = "DWF_LEARNING_LAST_SEEN_ANNOUNCEMENT_AT";

const getLastSeenStorageKey = (userId: string) =>
  `${LAST_SEEN_ANNOUNCEMENT_KEY}_${userId}`;

export const getLastSeenAnnouncementAt = (user?: any) => {
  if (!user) return null;

  const recordValue = user[teacherFieldIds.lastSeenAnnouncementAt];
  if (recordValue) {
    return new Date(recordValue);
  }

  if (!user.id) return null;
  const storedValue = getSession(getLastSeenStorageKey(user.id));
  return storedValue ? new Date(storedValue) : null;
};

export const setLastSeenAnnouncementAtLocal = (userId: string, lastSeen: Date) => {
  if (!userId || !lastSeen) return;
  setSession(getLastSeenStorageKey(userId), lastSeen.toISOString());
};

export const getLatestAnnouncementDate = (announcements: Announcement[]) => {
  if (!announcements || announcements.length === 0) return null;
  return announcements.reduce<Date | null>((latest, item) => {
    const candidate = new Date(item[airtableFields.announcements.liveDate]);
    if (!latest || candidate > latest) {
      return candidate;
    }
    return latest;
  }, null);
};

export const getHasUnreadAnnouncements = (
  announcements: Announcement[],
  lastSeen: Date | null
) => {
  const latest = getLatestAnnouncementDate(announcements);
  if (!latest) return false;
  if (!lastSeen) return true;
  return latest > lastSeen;
};
